module.exports = "33693948bf0bc3731306992e285536ff.png";


//////////////////
// WEBPACK FOOTER
// ./assets/sprites/shrine-top-l-3.png
// module id = 60
// module chunks = 0